/**
 * Format ISO8601 date string to long format (Month DD, YYYY)
 * @param dateString ISO8601 date string (YYYY-MM-DD)
 * @returns Long formatted date string or undefined if invalid
 */
export function formatReassignmentDateLong(dateString: string): string | undefined {
  const date = new Date(Date.parse(dateString))

  if (Number.isNaN(date.getTime())) {
    return undefined
  }

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  })
}

/**
 * Format ISO8601 date string to short format (MM/DD/YY)
 * @param dateString ISO8601 date string (YYYY-MM-DD)
 * @returns Short formatted date string or undefined if invalid
 */
export function formatReassignmentDateShort(dateString: string): string | undefined {
  const date = new Date(Date.parse(dateString))

  if (Number.isNaN(date.getTime())) {
    return undefined
  }

  // Display in UTC to match how ISO8601 date-only strings are parsed
  return date.toLocaleDateString('en-US', {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'UTC',
  })
}
